import { Container, Row, Col } from "react-bootstrap";
import Breadcrumb from "../shared/breadcrumb";

const SearchHeader = (props) => {
  console.log(props);
  const {
    title = "Browse The Best Around You",
    subtitle = "More Than 1000 Products",
  } = props;
  return (
    <div className="search-header ">
      <Container className="ps-5 py-4">
        <Row className="align-items-center">
          <Col xs="auto">
            <Breadcrumb
              items={[
                { label: "Search", href: "/search" },
                false ? { label: title } : null,
              ]}
            />
          </Col>
          <Col sm="8">
            <div className="search-title text-center">
              <h1
                className="fs-5 mb-0 fw-normal text-dark"
                dangerouslySetInnerHTML={{ __html: title }}
              ></h1>
            </div>
          </Col>
          <Col xs="auto">
            {/* <h3 className="mb-0 text-uppercase fw-bold font-md text-grey mb-0">
              {subtitle}
            </h3> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SearchHeader;
